module.exports = __webpack_public_path__ + "img/1.8127f18a.png";